import React from 'react';
import styles from './stream_is_over.less';
import { OmniaVideo } from '@omniafishing/core';
import { getIsOver } from './omnia_video_page_container';

export const StreamIsOver = ({ omnia_video }: { omnia_video: OmniaVideo }) => {
  const { event_end, livestream, summary, thumbnail } = omnia_video;
  const isOver = getIsOver(event_end, livestream);

  return (
    <>
      {isOver && (
        <>
          <section className={styles.concluded}>
            <p>
              This live event has concluded. Check out some of the products featured during the
              event below.
            </p>

            <p className={styles.concludedSummary}>{summary}</p>
          </section>
          <div>
            <img className={styles.heroImg__concluded} src={thumbnail} />
          </div>
        </>
      )}
    </>
  );
};
